angular.module('TetherApp').directive('sweepstakesPrizeForm', function () {
    return {
        restrict: 'E',
        templateUrl: '/html/experience/sweepstakes/sweepstakesPrizeForm.html'
    }
});
